import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Instagram, ShoppingBag } from "lucide-react";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: "/", label: "HOME" },
    { path: "/about", label: "ABOUT" },
    { path: "/shop", label: "SHOP" },
    { path: "/contact", label: "CONTACT" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav 
      className="fixed top-0 left-0 right-0 z-50 bg-[var(--obvious-white)] border-b-4 border-[var(--obvious-black)]"
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link 
            to="/" 
            className="flex items-center group"
            data-testid="nav-logo"
          >
            <div className="border-4 border-[var(--obvious-black)] rounded-xl px-4 py-2 bg-[var(--obvious-white)] transition-all group-hover:bg-[var(--obvious-black)] group-hover:text-[var(--obvious-white)]">
              <span className="font-['Anton'] text-2xl tracking-tight">OBVIOUS</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`retro-link text-lg ${
                  isActive(link.path) ? "text-[var(--obvious-teal)]" : ""
                }`}
                data-testid={`nav-link-${link.label.toLowerCase()}`}
              >
                {link.label}
              </Link>
            ))}
            
            {/* External Links */}
            <a
              href="https://www.instagram.com/obvious_signs"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 border-4 border-[var(--obvious-black)] bg-[var(--obvious-coral)] text-white hover:bg-[var(--obvious-black)] transition-colors wiggle"
              data-testid="nav-instagram"
              aria-label="Instagram"
            >
              <Instagram size={24} strokeWidth={3} />
            </a>
            <Link
              to="/shop"
              className="p-2 border-4 border-[var(--obvious-black)] bg-[var(--obvious-yellow)] text-black hover:bg-[var(--obvious-black)] hover:text-white transition-colors wiggle"
              data-testid="nav-shop-icon"
              aria-label="Shop the Collective"
            >
              <ShoppingBag size={24} strokeWidth={3} />
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2 border-4 border-[var(--obvious-black)] bg-[var(--obvious-teal)]"
            data-testid="nav-mobile-toggle"
            aria-label="Toggle menu"
          >
            {isOpen ? <X size={28} strokeWidth={3} /> : <Menu size={28} strokeWidth={3} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div 
          className="md:hidden bg-[var(--obvious-yellow)] border-t-4 border-[var(--obvious-black)]"
          data-testid="nav-mobile-menu"
        >
          <div className="px-4 py-6 space-y-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className={`block font-['Anton'] text-2xl uppercase ${
                  isActive(link.path) 
                    ? "text-[var(--obvious-purple)]" 
                    : "text-[var(--obvious-black)]"
                }`}
                data-testid={`nav-mobile-link-${link.label.toLowerCase()}`}
              >
                → {link.label}
              </Link>
            ))}
            <div className="flex gap-4 pt-4 border-t-4 border-[var(--obvious-black)]">
              <a
                href="https://www.instagram.com/obvious_signs"
                target="_blank"
                rel="noopener noreferrer"
                className="flex-1 p-3 border-4 border-[var(--obvious-black)] bg-[var(--obvious-coral)] text-white text-center font-['Anton'] text-lg"
                data-testid="nav-mobile-instagram"
              >
                INSTAGRAM
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
